var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { API } from './api';
import { BaseProvider } from './base';
import { JobProvider, JobType } from './job';
import { APIUsageProvider } from './api_usage';
import { ModalProvider } from './popup/modal';
import { BrainBankErrorCode } from './error-code';
import { TrackableJobProvider } from './trackable-job';
import { TranslateService } from '@ngx-translate/core';
var BOOST_JOB_TYPES = [JobType.Retrain, JobType.Optimize, JobType.Freeze, JobType.Train, JobType.AnomalyHiFi];
export var STATE_DESCRIPTION_RECALCULATE = 'Recalculating Accuracy';
/**
 * It's up to the job tracking frontend components to interpret the state information from the boost provider.
 * The expected state flow is
 *      OUT_OF_SYNC/READY -> WAITING -> IN_PROGRESS -> RECALCULATE -> DONE/ERROR,
 *      or
 *      OUT_OF_SYNC/READY -> WAITING -> IN_PROGRESS -> RECALCULATE -> CANCELING -> CANCELED.
 */
export var BoostJobUXState;
(function (BoostJobUXState) {
    /** The dataset is in sync with the brain, however there are newly tagged images that need training */
    BoostJobUXState["NEEDS_INCREMENTAL_TRAINING"] = "NeedsIncrementalTraining";
    /** The dataset is out of sync with the brain */
    BoostJobUXState["OUT_OF_SYNC"] = "OutOfSyncWarning";
    /**
     * This corresponds to the front end state where a user can configure and then
     * press a button to launch a job. This does NOT correspond to the back end job
     * Ready state
     */
    BoostJobUXState["READY"] = "Ready";
    /** A boost job has been initiated and is waiting to start */
    BoostJobUXState["WAITING"] = "Waiting";
    /** A boost job is currently in progress */
    BoostJobUXState["IN_PROGRESS"] = "In Progress";
    /** A boost job is currently recalculating accuracy */
    BoostJobUXState["RECALCULATE"] = "Recalculating Accuracy";
    /** A boost job has completed successfully */
    BoostJobUXState["DONE"] = "Done";
    /** A boost job has failed */
    BoostJobUXState["ERROR"] = "Error";
    /** A boost job is currently being canceled */
    BoostJobUXState["CANCELING"] = "Canceling";
    /** A boost job has been canceled */
    BoostJobUXState["CANCELED"] = "Canceled";
})(BoostJobUXState || (BoostJobUXState = {}));
export var MOCK_BOOST_ESTIMATE_MULTIPLIER = 0.1; // Represents 100 milliseconds
export var Platform;
(function (Platform) {
    Platform["Linux_x86_CUDA"] = "Linux-x86-CUDA";
    Platform["Linux_x86_CPU"] = "Linux-x86-CPU";
    Platform["iOS"] = "iOS";
    Platform["Android"] = "Android";
})(Platform || (Platform = {}));
export var OptimizeTag;
(function (OptimizeTag) {
    // Used for Scene/Anomaly Recognition Learning optimization
    OptimizeTag["Small"] = "Small";
    OptimizeTag["Medium"] = "Medium";
    OptimizeTag["Large"] = "Large";
    OptimizeTag["Explainability"] = "Explainability";
    // Used for FLIR account tiers
    OptimizeTag["Firefly"] = "Firefly";
    OptimizeTag["Firefly30"] = "Firefly30";
    OptimizeTag["Firefly45"] = "Firefly45";
    OptimizeTag["Firefly60"] = "Firefly60";
    // Used for HiFi training
    OptimizeTag["HiFiCoarse"] = "HiFiCoarse";
    OptimizeTag["HiFiRegular"] = "HiFiRegular";
    OptimizeTag["HiFiFine"] = "HiFiFine";
    OptimizeTag["HiFiUltraFine"] = "HiFiUltraFine";
    // If set, tells BrainBank to re-use the backbone from the current brainVersion
    OptimizeTag["Reuse"] = "Reuse";
})(OptimizeTag || (OptimizeTag = {}));
export var HiFiDefectSizing;
(function (HiFiDefectSizing) {
    HiFiDefectSizing["OptimizeForDataset"] = "OptimizeForDataset";
    HiFiDefectSizing["Coarse"] = "Coarse";
    HiFiDefectSizing["Regular"] = "Regular";
    HiFiDefectSizing["Fine"] = "Fine";
    HiFiDefectSizing["UltraFine"] = "UltraFine";
})(HiFiDefectSizing || (HiFiDefectSizing = {}));
var BoostProvider = /** @class */ (function (_super) {
    __extends(BoostProvider, _super);
    function BoostProvider(api, jobProvider, trackableJobProvider, modalProvider, apiUsageProvider, translate) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.jobProvider = jobProvider;
        _this.trackableJobProvider = trackableJobProvider;
        _this.modalProvider = modalProvider;
        _this.apiUsageProvider = apiUsageProvider;
        _this.translate = translate;
        return _this;
    }
    /**
     * Run incrementally training for the specified dataset
     *
     * @param datasetIdentifier Unique identifier for the dataset
     * @param sendEmail Specify true to send an email to the user when the retrain job completes
     */
    BoostProvider.prototype.incrementalTrain = function (datasetIdentifier, sendEmail) {
        if (sendEmail === void 0) { sendEmail = false; }
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/incremental", {
                                sendEmail: sendEmail
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.trackableJobProvider.notifyJobRequestFailed(datasetIdentifier, JobType.Retrain);
                        throw error_1;
                    case 3: return [4 /*yield*/, this.trackableJobProvider.restartJobPolling()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrain the specified dataset
     *
     * @param datasetIdentifier Unique identifier for the dataset
     * @param sendEmail Specify true to send an email to the user when the retrain job completes
     */
    BoostProvider.prototype.retrain = function (datasetIdentifier, sendEmail) {
        if (sendEmail === void 0) { sendEmail = false; }
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/retrain", {
                                sendEmail: sendEmail
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        this.trackableJobProvider.notifyJobRequestFailed(datasetIdentifier, JobType.Retrain);
                        throw error_2;
                    case 3: return [4 /*yield*/, this.trackableJobProvider.restartJobPolling()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Optimize the specified dataset
     *
     * @param datasetIdentifier Unique identifier for the dataset
     * @param optimizationLevers Execution parameters for the optimization job
     */
    BoostProvider.prototype.optimize = function (datasetIdentifier, optimizationLevers) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/optimize", optimizationLevers)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        this.trackableJobProvider.notifyJobRequestFailed(datasetIdentifier, JobType.Optimize);
                        throw error_3;
                    case 3: return [4 /*yield*/, this.trackableJobProvider.restartJobPolling()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Freeze the specified dataset
     *
     * @param datasetIdentifier Unique identifier for the dataset
     * @param optimizationLevers Execution parameters for the freeze job
     */
    BoostProvider.prototype.freeze = function (datasetIdentifier, optimizationLevers) {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/freeze", optimizationLevers)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        this.trackableJobProvider.notifyJobRequestFailed(datasetIdentifier, JobType.Freeze);
                        throw error_4;
                    case 3: return [4 /*yield*/, this.trackableJobProvider.restartJobPolling()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Run detection train for the specified dataset
     *
     * @param datasetIdentifier Unique identifier for the dataset
     * @param detectionTrainLevers Execution parameters for the detection train job
     */
    BoostProvider.prototype.trainDetection = function (datasetIdentifier, detectionTrainLevers) {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/detection", detectionTrainLevers)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        this.trackableJobProvider.notifyJobRequestFailed(datasetIdentifier, JobType.Train);
                        throw error_5;
                    case 3: return [4 /*yield*/, this.trackableJobProvider.restartJobPolling()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Run anomaly hi-fi training for the specified dataset
     *
     * @param datasetIdentifier Unique identifier for the dataset
     * @param optimizationLevers Execution parameters for the anomaly hi-fi job
     */
    BoostProvider.prototype.buildAnomalyHiFi = function (datasetIdentifier, optimizationLevers) {
        return __awaiter(this, void 0, void 0, function () {
            var error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/anomalyhifi", optimizationLevers)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        this.trackableJobProvider.notifyJobRequestFailed(datasetIdentifier, JobType.AnomalyHiFi);
                        throw error_6;
                    case 3: return [4 /*yield*/, this.trackableJobProvider.restartJobPolling()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Display the RetrainProgressModal indicating whether the dataset needs to be retrained,
     * is currently retraining or is in a clean state.
     *
     * @param datasetIdentifier Unique identifier for the dataset
     * @param initialBoostState Specify whether we are displaying the modal as a result
     * of the user taking action on either a brain-out-of-sync warning or that incremental training
     * is required
     */
    BoostProvider.prototype.showRetrainProgress = function (datasetIdentifier, initialBoostState, dismissPreviousJob) {
        if (initialBoostState === void 0) { initialBoostState = BoostJobUXState.OUT_OF_SYNC; }
        if (dismissPreviousJob === void 0) { dismissPreviousJob = false; }
        // If we already have a retrain modal open, don't create a new one.
        // For this to work, we need to explictly clean up the modal when it's closed.
        if (this.modalProvider.modalIsOpen('RetrainProgressModal')) {
            return;
        }
        var continueMethod = initialBoostState === BoostJobUXState.NEEDS_INCREMENTAL_TRAINING
            ? this.continueWithIncrementalTrain
            : this.continueWithRetrain;
        this.retrainProgressModal = this.modalProvider.createModal('RetrainProgressModal', {
            datasetIdentifier: datasetIdentifier,
            continueWithRetrain: continueMethod.bind(this),
            initialBoostState: initialBoostState,
            dismissPreviousJob: dismissPreviousJob
        }, { cssClass: 'retrain-progress', enableBackdropDismiss: false });
        this.retrainProgressModal.present();
    };
    BoostProvider.prototype.continueWithIncrementalTrain = function (sendEmail, datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.incrementalTrain(datasetIdentifier, sendEmail)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        if (err_1 && err_1.error && err_1.error.code == BrainBankErrorCode.DatasetBusy && this.retrainProgressModal) {
                            this.retrainProgressModal.dismiss();
                            this.retrainProgressModal = undefined;
                        }
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BoostProvider.prototype.continueWithRetrain = function (sendEmail, datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.retrain(datasetIdentifier, sendEmail)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        if (err_2 && err_2.error && err_2.error.code == BrainBankErrorCode.DatasetBusy && this.retrainProgressModal) {
                            this.retrainProgressModal.dismiss();
                            this.retrainProgressModal = undefined;
                        }
                        throw err_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BoostProvider.prototype.cancelIncrementalTrain = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var cancelResponse, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/incremental/cancel")];
                    case 1:
                        cancelResponse = _a.sent();
                        return [2 /*return*/, {
                                success: cancelResponse ? cancelResponse.success : false
                            }];
                    case 2:
                        error_7 = _a.sent();
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BoostProvider.prototype.cancelRetrain = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var cancelResponse, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/retrain/cancel")];
                    case 1:
                        cancelResponse = _a.sent();
                        return [2 /*return*/, {
                                success: cancelResponse ? cancelResponse.success : false
                            }];
                    case 2:
                        error_8 = _a.sent();
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BoostProvider.prototype.cancelOptimization = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var cancelResponse, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/optimize/cancel")];
                    case 1:
                        cancelResponse = _a.sent();
                        return [2 /*return*/, {
                                success: cancelResponse ? cancelResponse.success : false
                            }];
                    case 2:
                        error_9 = _a.sent();
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BoostProvider.prototype.cancelFreeze = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var cancelResponse, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/freeze/cancel")];
                    case 1:
                        cancelResponse = _a.sent();
                        return [2 /*return*/, {
                                success: cancelResponse ? cancelResponse.success : false
                            }];
                    case 2:
                        error_10 = _a.sent();
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BoostProvider.prototype.cancelAnomalyHiFi = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var cancelResponse, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/anomalyhifi/cancel")];
                    case 1:
                        cancelResponse = _a.sent();
                        return [2 /*return*/, {
                                success: cancelResponse ? cancelResponse.success : false
                            }];
                    case 2:
                        error_11 = _a.sent();
                        throw error_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BoostProvider.prototype.cancelDetectionTraining = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var cancelResponse, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/train/detection/cancel")];
                    case 1:
                        cancelResponse = _a.sent();
                        return [2 /*return*/, {
                                success: cancelResponse ? cancelResponse.success : false
                            }];
                    case 2:
                        error_12 = _a.sent();
                        throw error_12;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Return a string describing how much remaining work exists for the specified job
     * that is currently in the Processing state
     *
     * @param job The job for which to return the description
     * @param brain The brain associated with the boosting job
     */
    BoostProvider.prototype.computeEstimateWithUnitsAndLabel = function (job, brain) {
        var _a = this.computeLatestEstimate(job, brain), rawTime = _a.rawTime, currentStep = _a.currentStep, totalSteps = _a.totalSteps;
        if (currentStep == -1 || rawTime == undefined || rawTime < 0 || this.stillCalculatingEstimate(totalSteps)) {
            return this.translate.instant('Calculating time remaining...');
        }
        else if (this.isLastStepInJob(currentStep, totalSteps) ||
            (this.isAbovePercent(currentStep, totalSteps, 95) && rawTime < 10)) {
            return this.translate.instant('Finishing up...');
        }
        else {
            var translateReplacements = {
                estimate: this.formatEstimate(rawTime)
            };
            return this.translate.instant('About [[estimate]] remaining', translateReplacements);
        }
    };
    BoostProvider.prototype.isLastStepInJob = function (curr, total) {
        return curr === total;
    };
    BoostProvider.prototype.stillCalculatingEstimate = function (total) {
        return total === 1;
    };
    /**
     * Returns true if division produces a number above supplied percent
     */
    BoostProvider.prototype.isAbovePercent = function (numerator, denominator, percent) {
        if (!numerator || !denominator || !percent || denominator === 0) {
            return false;
        }
        return (numerator / denominator) * 100 > percent;
    };
    BoostProvider.prototype.formatEstimate = function (estimate) {
        // Round to the nearest second
        return this.apiUsageProvider.formatUsageUnit(estimate, 'sec', 0, true);
    };
    /**
     * Return the estimated time remaining for the boost job currently runnning for the specified dataset.
     * Return a default estimate if no job is currently running
     *
     * @param job The job for which to return the description
     * @param brain The brain associated with the boosting job
     */
    BoostProvider.prototype.computeLatestEstimate = function (job, brain) {
        var errorEstimate = { rawTime: 0, currentStep: -1, totalSteps: 1 };
        if (!job || !brain) {
            return errorEstimate;
        }
        if (job.type == JobType.Retrain) {
            if (!job || !job.current) {
                // Show the mock estimate for the first step.
                return { rawTime: MOCK_BOOST_ESTIMATE_MULTIPLIER * brain.numFrames, currentStep: -1, totalSteps: 1 };
            }
            else {
                /* A retrain job has three steps - training tasks against
                 * various subsets of the dataset's assets.
                 */
                switch (job.current) {
                    case 0:
                        return {
                            rawTime: MOCK_BOOST_ESTIMATE_MULTIPLIER * brain.numFrames,
                            currentStep: 0,
                            totalSteps: job.total || 0
                        };
                    case 1:
                        return {
                            rawTime: MOCK_BOOST_ESTIMATE_MULTIPLIER * brain.numTrainedPolygons,
                            currentStep: 1,
                            totalSteps: job.current
                        };
                    case 2:
                        return {
                            rawTime: MOCK_BOOST_ESTIMATE_MULTIPLIER * brain.numValidationPolygons,
                            currentStep: 2,
                            totalSteps: job.current
                        };
                    default:
                        return errorEstimate;
                }
            }
        }
        else {
            if (!job.current || !job.total || !job.dateProcessingStartedSeconds) {
                return errorEstimate;
            }
            // When optimizing, we can estimate time by tracking how long each step takes,
            // and multiplying by the total amount of steps required to complete the job.
            var now = new Date();
            var jobStart = new Date(job.dateProcessingStartedSeconds * 1000);
            var millisecondsPerStep = (now.getTime() - jobStart.getTime()) / (job.current == 1 ? job.current : job.current - 1);
            var estimateTime = Math.ceil((millisecondsPerStep * (job.total - job.current)) / 1000);
            return { rawTime: estimateTime, currentStep: job.current, totalSteps: job.total };
        }
    };
    BoostProvider.prototype.isBoostJobType = function (jobType) {
        return BOOST_JOB_TYPES.includes(jobType);
    };
    BoostProvider.prototype.getCancelFailedMessage = function (uxState, jobType, isRerunning) {
        if (isRerunning === void 0) { isRerunning = false; }
        var jobTypeString = '';
        switch (jobType) {
            case JobType.Retrain:
                jobTypeString = this.translate.instant('Retraining').toLowerCase();
                break;
            case JobType.Optimize:
                jobTypeString = this.translate.instant('Optimization').toLowerCase();
                break;
            case JobType.Freeze:
            case JobType.AnomalyHiFi:
                jobTypeString = isRerunning
                    ? this.translate.instant('Rebuilding').toLowerCase()
                    : this.translate.instant('Building').toLowerCase();
                break;
            case JobType.Train:
                jobTypeString = isRerunning
                    ? this.translate.instant('Retraining').toLowerCase()
                    : this.translate.instant('Training').toLowerCase();
                break;
        }
        if (uxState !== BoostJobUXState.ERROR && uxState !== BoostJobUXState.DONE) {
            return '';
        }
        var translateReplacements = {
            jobType: jobTypeString,
            resultState: uxState === BoostJobUXState.ERROR
                ? this.translate.instant('Failed').toLowerCase()
                : this.translate.instant('completed successfully')
        };
        return this.translate.instant('We were unable to complete your cancel request because the [[jobType]] job has already [[resultState]]', translateReplacements);
    };
    BoostProvider.prototype.getComprehensivenessOfOptimizationText = function () {
        return this.translate.instant('Choose the optimal comprehensiveness for your model.<br><br>A quick optimization will evaluate a number of our model options and determine the best fit for your Brain.<br><br>A balanced optimization will evaluate a majority of our model options and determine the best fit for your Brain.<br><br>Finally, a thorough optimization will evaluate every possible model option and determine the best fit for your Brain. A thorough optimization takes the most time. Keep in mind, time estimations are based on the amount of data in your dataset.');
    };
    BoostProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API,
            JobProvider,
            TrackableJobProvider,
            ModalProvider,
            APIUsageProvider,
            TranslateService])
    ], BoostProvider);
    return BoostProvider;
}(BaseProvider));
export { BoostProvider };
//# sourceMappingURL=boost.js.map


// WEBPACK FOOTER //
// ./src/providers/boost.ts.pre-build-optimizer.js